import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';

import { useBackCompressiveForceEstimationContext } from '../context';
import { useSessionStorage } from '@/hooks/useSessionStorage';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { PreviousCol } from './styles';

interface FooterProps {
	currentStep: number;
	onStepChange(step: number): void;
}

export const Footer: React.FC<FooterProps> = ({ onStepChange, currentStep }) => {
	const history = useHistory();
	const { steps, gettingReport } = useBackCompressiveForceEstimationContext();
	const [nameLocal] = useLocalStorage('liberty-mutual', false);
	const [nameSession, setNameSession] = useSessionStorage('liberty-mutual', false);
	const [cameFromCustomReport, setCameFromCustomReport] = useState<boolean>(false);

	useEffect(() => {
		if (nameLocal || nameSession) {
			setCameFromCustomReport(true);
			localStorage.removeItem('liberty-mutual');
			sessionStorage.removeItem('liberty-mutual');
			setNameSession(true);
		}
	}, [nameLocal]);

	function handleNextStep() {
		onStepChange(currentStep + 1);
	}

	function handlePreviousStep() {
		onStepChange(currentStep - 1);
	}

	function redirectToReports() {
		cameFromCustomReport ? window.close() : history.push('/reporting');
	}

	if (currentStep === steps.length - 1) {
		return (
			<Row>
				<Col xs={24} style={{ marginTop: '2rem' }}>
					<Row justify="center" align="middle" gutter={[0, 8]}>
						<PreviousCol>
							<Button loading={gettingReport} type="default" onClick={handlePreviousStep}>
								{I18n.get('Previous')}
							</Button>
						</PreviousCol>
						<Col>
							<Button
								loading={gettingReport}
								disabled={gettingReport}
								type="primary"
								onClick={redirectToReports}
							>
								{I18n.get('Close')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	if (currentStep > 0) {
		return (
			<Row>
				<Col xs={24} style={{ marginTop: '2rem' }}>
					<Row justify="center" align="middle" gutter={[0, 8]}>
						<PreviousCol>
							<Button loading={gettingReport} type="default" onClick={handlePreviousStep}>
								{I18n.get('Previous')}
							</Button>
						</PreviousCol>
						<Col>
							<Button
								type="primary"
								htmlType="submit"
								loading={gettingReport}
								disabled={gettingReport}
								onClick={handleNextStep}
							>
								{I18n.get('Next')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	return (
		<Row>
			<Col xs={24} style={{ marginTop: '2rem' }}>
				<Row justify="center">
					<Col>
						<Button htmlType="submit" loading={gettingReport} type="primary" onClick={handleNextStep}>
							{I18n.get('Next')}
						</Button>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};
